var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDhl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 40,
    viewBox: "0 0 288 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_7136_69961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.624023 37H35.424L33.424 39.8H0.624023V37Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.624 39.8H245.024L247.224 37H287.824V39.8H287.624Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.624023 31.8008H39.424L37.224 34.6008H0.624023V31.8008Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.624023 26.6016H43.424L41.224 29.4016H0.624023V26.6016Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.624 34.6008H249.024L251.224 31.8008H287.824V34.6008H287.624Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.024 26.6016H287.624V29.4016H252.824L255.024 26.6016Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2236 39.8012L56.6236 15.2012C56.6236 15.2012 77.0236 15.2012 79.4236 15.2012C82.0236 15.2012 82.0236 16.2012 80.6236 17.8012C79.4236 19.4012 77.2236 22.4012 76.0236 24.0012C75.4236 25.0012 74.2236 26.4012 78.0236 26.4012C82.2236 26.4012 108.624 26.4012 108.624 26.4012C106.224 30.0012 97.8236 40.0012 83.0236 40.0012C71.0236 39.8012 38.2236 39.8012 38.2236 39.8012Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.624 26.6016L133.624 40.0016H107.424L117.424 26.6016H143.624Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.824 26.6016L171.824 40.0016H145.424L155.424 26.6016H181.824Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.424 26.6016C190.424 26.6016 188.424 29.2016 187.624 30.4016C184.224 34.8016 187.224 40.0016 198.024 40.0016C210.424 40.0016 240.424 40.0016 240.424 40.0016L250.424 26.6016H190.424Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2244 0.000781253L42.0244 12.2008C42.0244 12.2008 89.4244 12.2008 92.0244 12.2008C94.6244 12.2008 94.6244 13.2008 93.2244 14.8008C92.0244 16.4008 89.8244 19.4008 88.6244 21.0008C88.0244 21.8008 86.8244 23.4008 90.6244 23.4008C94.8244 23.4008 111.024 23.4008 111.024 23.4008C111.024 23.4008 114.424 19.0008 117.024 15.2008C120.824 10.2008 117.424 -0.199219 104.024 -0.199219C92.0244 0.000781253 51.2244 0.000781253 51.2244 0.000781253Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.024 23.4H119.624L137.224 0H163.624L153.624 13.4H165.424L175.424 0H201.824L184.024 23.4Z",
    fill: "#545859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.224 0L220.624 23.4H192.624L210.224 0H238.224Z",
    fill: "#545859"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7136_69961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287,
    height: 40,
    fill: "white",
    transform: "translate(0.624023)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/dhl.76c5b546dda10efa8e1123c590c4350a.svg";
export { ForwardRef as ReactComponent };